/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloneTemplateRequest {
    getFixupPrototypeFunction() { return CloneTemplateRequest.fixupPrototype; }

    static newInstance(model: Partial<CloneTemplateRequest>): CloneTemplateRequest {
        let obj = Object.assign(new CloneTemplateRequest(), model);
        CloneTemplateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloneTemplateRequest>): CloneTemplateRequest {
        if (!model) return null;
        return CloneTemplateRequest.newInstance(<CloneTemplateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloneTemplateRequest) {
        if (!obj) return;

        models.CloneTemplateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloneTemplateRequest): boolean {
        Object.setPrototypeOf(obj, CloneTemplateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.constraints) {
            models.ConstraintsRequest.fixupPrototype(this.constraints);
        }
    }

    /**
     * Provide the clone template name.
     */
    clone_template_name: string;

    /**
     * Boolean value to set template as default not not
     */
    is_default: boolean;

    /**
     * Provide cloud_account_id when scope is selected as cloud_account scope
     */
    cloud_account_id: Array<string>;

    /**
     * Select regions when scope is selected as region for an AWS cloud
     */
    regions: Array<string>;

    /**
     * Select resource_groups when scope is selected as resource_group for an Azure cloud
     */
    resource_groups: Array<string>;

    /**
     * Select the check box, if wish to apply the configuration for existing resources also
     */
    apply_to_existing_resource: boolean;

    /**
     * scope for the template to be cloned
     */
    scope: string;

    /**
     * monitoring_template_uri of a template from which it is being cloned
     */
    source_monitoring_template_uri: string;

    /**
     * Provide the constraints, if the template need to be mapped with constraints
     */
    constraints: models.ConstraintsRequest;

}
